import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

export type RecapOption = {
  value: string
  upgraded: boolean
}

type UpgradePickerFields = NonNullable<
  GetPickersResponse['upgrade']
>['pickerFields']

export function resolveRecapOptions(
  selectedOptions: string[],
  upgradePickerFields?: UpgradePickerFields,
): RecapOption[] {
  if (!upgradePickerFields) {
    return selectedOptions.map((option) => ({ value: option, upgraded: false }))
  }

  const upgradedFields = Object.values(upgradePickerFields)

  return selectedOptions.map((option, index) => {
    const upgradedField = upgradedFields[index]

    return {
      value: upgradedField.value,
      upgraded: upgradedField.upgrade,
    }
  })
}
